import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';
import {TranslateModule} from '@ngx-translate/core';
import {ToolbarButtonComponent} from './toolbar-button/toolbar-button.component';
import {ToolbarComponent} from './toolbar.component';

@NgModule({
  declarations: [
    ToolbarComponent,
    ToolbarButtonComponent,
  ],
    imports: [
        // Angular
        CommonModule,
        // Material
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
    ],
  exports: [
    ToolbarComponent,
    ToolbarButtonComponent,
  ],
})
export class ToolbarModule {}
